// assets/slideshow-click.js
(function () {
  function wire(comp) {
    if (!comp || comp.dataset.clickwired === 'true') return;

    comp.addEventListener('click', function (e) {
      // ignore clicks on controls or any links/buttons on top
      if (e.target.closest('.slider-button, .slideshow__controls, a, button')) return;

      const slide = e.target.closest('.slideshow__slide');
      if (!slide) return;

      // find the visible media box inside the slide
      const media =
        slide.querySelector('.slideshow__media, .banner__media, .media');
      if (!media) return;

      const rect = media.getBoundingClientRect();
      const x = e.clientX, y = e.clientY;

      // only act if the click fell within the media box
      if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) return;

      const prevBtn = comp.querySelector('.slider-button--prev');
      const nextBtn = comp.querySelector('.slider-button--next');
      if (!prevBtn || !nextBtn) return;

      // left half = previous, right half = next
      (x - rect.left < rect.width / 2 ? prevBtn : nextBtn).click();
    });

    comp.dataset.clickwired = 'true';
  }

  function initAll() {
    document.querySelectorAll('slideshow-component').forEach(wire);
  }

  // cover all render paths
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
